.container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
}

.nav {
  display: flex;
  justify-content: space-around;
  background-color: var(--tuna-palette-layers);
  border-top: 1px solid var(--tuna-palette-divider);
  padding: 4px 0;
}

.navButton {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 12px;
  font-size: var(--tuna-typography-fontSize-xs);
}
